
import { FC } from "react";

interface FrankAvatarProps {
  size?: "sm" | "md";
  className?: string;
}

const FrankAvatar: FC<FrankAvatarProps> = ({ size = "md", className = "" }) => {
  const sizeClasses = size === "sm" ? "w-8 h-8" : "w-10 h-10";
  
  return (
    <div className={`${sizeClasses} ${className}`}>
      <div className="w-full h-full bg-gradient-to-br from-[#2F80ED] to-[#1B365D] rounded-full flex items-center justify-center">
        <img 
          src="/lovable-uploads/9048b14a-0627-4181-9970-b70f455db5ac.png"
          alt="Frank AI"
          className="w-full h-full object-cover rounded-full"
          loading="eager"
        />
      </div>
    </div>
  );
};

export default FrankAvatar;
